
import Vue from "vue";
import mapCom from "@/components/MapCom.vue";
import box from "@/components/BoxCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import pie from "@/components/Charts/PieCharCom.vue";
import { EchartInitModel } from "@/assets/js/Model/InnerModel";
import lineChart from "@/components/Charts/LineChartCom.vue";
import rline from "@/components/Charts/RLineChartCom.vue";
import Utils from "@/assets/js/Utils";
import alarmAnimate from "@/components/AlarmAnimateCom.vue";
export default Vue.extend({
  components: { mapCom, box, pie, lineChart, rline, alarmAnimate },
  mounted() {
    this.map = this.$refs.map;
    this.map.init(true);
    this.initLightChart();
    this.initDeviceChart();
    this.initOrderStateChart();
    this.engChart();
    this.getOrderList();
  },
  data() {
    return {
      currentOrder: null as any,
      map: null as any,
      loadingLight: false,
      loadingDeviceType: false,
      loadingOrderState: false,
      loadingEngChart: false,
      lightDetail: {} as any,
      deviceTypeDetail: {} as any,
      orderStateChat: {} as any,
      engMonthChat: {} as any,
      orderList: [] as any,
      tran: Utils.getTran(),
      choosed: true,
      currentSid: null as any,
      devcieTypes: [] as any[],
      deviceList: [] as any[],
    };
  },
  watch: {
    currentOrder() {
      const animi: any = this.$refs.alarmAni;
      if (this.currentOrder) {
        animi.start(true);
      } else {
        animi.start(false);
      }
    },
  },
  methods: {
    async getDevice() {
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDeviceListByCSid,
        this.currentSid,
        true,
        false
      );
      this.deviceList = ret;
      this.map.addDeviceNew(ret, this.currentSid, null);
    },
    async chooseDev(sid: string) {
      this.currentSid = sid;
      await this.getDevice();
    },
    scroll(left: any) {
      if (!this.$refs.chooseDevContent) {
        return;
      }
      const scroll: any = this.$refs.chooseDevContent.scrollWidth;
      var width = this.$refs.chooseDevContent.clientWidth;
      if (left) {
        if (this.$refs.chooseDevContent.scrollLeft + 100 > scroll - width + 100) {
          this.$refs.chooseDevContent.scrollTo(this.$refs.chooseDevContent.scrollLeft, 0);
        } else {
          this.$refs.chooseDevContent.scrollTo(
            this.$refs.chooseDevContent.scrollLeft + 100,
            0
          );
        }
      } else {
        if (this.$refs.chooseDevContent.scrollLeft - 100 <= 0) {
          this.$refs.chooseDevContent.scrollTo(0, 0);
        } else {
          this.$refs.chooseDevContent.scrollTo(
            this.$refs.chooseDevContent.scrollLeft - 100,
            0
          );
        }
      }
    },
    actionOrder() {
      if (this.currentOrder) {
        const routeObj = this.$router.resolve({
          path: `/Admin/OrderDetail?sid=${this.currentOrder.sid}`,
          // query: { sid: 'xxx' } // 需要参数直接写这里
        });
        window.open(routeObj.href, "_blank");
      }
    },
    currentChange(val: any) {
      this.currentOrder = val;
    },
    async getOrderList() {
      const data: any = {
        page: 0,
        pageSize: 100,
        conditions: [
          {
            field: "state",
            value: "3",
            conditionType: 3,
          },
        ],
      };
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetOrders, data, true, true);
      this.orderList = ret.data;
      if (this.orderList && this.orderList.length != 0) {
        this.currentOrder = this.orderList[0];
      }
    },
    async engChart() {
      this.loadingEngChart = true;
      const date = new Date();
      const month = date.getMonth() + 1;
      const req = await HttpUtil.XCHttpPost(Urls.GetMonthEnger, month, true, true);
      this.engMonthChat = req;
      this.loadingEngChart = false;
      const chart: any = this.$refs.engChart;
      let rdata: any[] = [];
      let labels: any[] = [];
      this.engMonthChat.forEach((ele: any) => {
        rdata.push({ name: ele.day, value: ele.total });
        labels.push(ele.day);
      });
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "本月能耗分析",
            Data: rdata,
          },
        ],
        LegendConfig: {
          top: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
        Labels: labels,
        Colors: ["rgb(243, 141, 10)"],
        Totate: false,
      };
      chart.setOption(opt);
    },
    async initOrderStateChart() {
      this.loadingOrderState = true;
      const req: any = await HttpUtil.XCHttpPost(Urls.GetOrderStateChat, "", true, true);
      this.orderStateChat = req;
      this.loadingOrderState = false;
      const chart: any = this.$refs.orderStateChat;
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "工单类型分析",
            Data: [
              { name: "未处理", value: this.orderStateChat.step1 },
              { name: "正处理", value: this.orderStateChat.step2 },
              { name: "已完成", value: this.orderStateChat.step3 },
            ],
          },
        ],
        LegendConfig: {
          bottom: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
      };
      chart.setOption(opt);
    },
    async initLightChart() {
      this.loadingLight = true;
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetDeviceDash, "", true, true);
      this.lightDetail = ret.deviceData;
      this.loadingLight = false;
      const chart: any = this.$refs.lightStateChat;
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "灯具亮灯率分析",
            Data: [
              { name: "总数量", value: this.lightDetail.total },
              { name: "亮灯数量", value: this.lightDetail.open },
            ],
          },
        ],
        LegendConfig: {
          bottom: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
      };
      chart.setOption(opt);
    },
    async initDeviceChart() {
      this.loadingDeviceType = true;
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetMapDeviceCount, "", true, true);
      this.deviceTypeDetail = ret;
      this.devcieTypes = this.deviceTypeDetail.filter(
        (item: any) => item.deviceCount > 0
      );
      this.loadingDeviceType = false;
      const chart: any = this.$refs.deviceTypeChat;
      let rdata: any[] = [];
      let labels: any[] = [];
      this.deviceTypeDetail.forEach((ele: any) => {
        rdata.push({ name: ele.categoryName, value: ele.deviceCount });
        labels.push(ele.categoryName);
      });
      let opt: EchartInitModel = {
        Data: [
          {
            Name: "设备类型",
            Data: rdata,
          },
        ],
        LegendConfig: {
          top: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
        Labels: labels,
        Colors: ["rgb(243, 141, 10)"],
        Totate: false,
      };
      chart.setOption(opt);
    },
  },
});
